import { useState, useEffect } from 'react';
import { TaskStatus } from '../../services/TaskStatus';

export const useWorkflowState = (ticket) => {
    const [stateTasks, setStateTasks] = useState([]);

    const getTaskCompletions = (t, taskId) => {
        let taskCompletions = (t ? t.taskCompletionStates : []) || []
        return taskCompletions.filter(x => x.workflowTaskId === taskId);
    }

    useEffect(() => {
        // get the tasks needed to reach the next state
        // filter out the ones without a target as they will be additional tasks
        var transitionTasks = ((ticket ? ticket.workflowStateTransitionTasks : null) || []).filter(t => t.targetType != null)

        // now see if we have completion info for any of them
        let st = []

        transitionTasks.forEach(t => {
            let tc = getTaskCompletions(ticket, t.workflowTask.identifier)
            if (tc.some(x => x.status === TaskStatus.COMPLETE)) {
                st.push({ identifier: t.workflowTask.identifier, status: TaskStatus.COMPLETE })
            } else if (tc.some(x => x.status === TaskStatus.FAILED)) {
                st.push({ identifier: t.workflowTask.identifier, status: TaskStatus.FAILED })
            } else if (tc.some(x => x.status === TaskStatus.IN_PROGRESS)) {
                st.push({ identifier: t.workflowTask.identifier, status: TaskStatus.IN_PROGRESS })
            } else {
                st.push({ identifier: t.workflowTask.identifier, status: TaskStatus.NOT_STARTED})
            }
        })
        setStateTasks(st);
    }, [ticket])

    return stateTasks;
}
